const STORAGE_KEY_PREFIX = "pencom:outstanding-penalty-notice-dismissed";

const getStorageKey = (employerCode: string) =>
  `${STORAGE_KEY_PREFIX}:${employerCode}`;

export const isOutstandingPenaltyNoticeDismissed = (
  employerCode: string
): boolean => {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(getStorageKey(employerCode)) === "true";
};

export const dismissOutstandingPenaltyNotice = (employerCode: string): void => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(getStorageKey(employerCode), "true");
};

export const clearOutstandingPenaltyNoticeDismissals = (): void => {
  if (typeof window === "undefined") return;
  const keysToRemove: string[] = [];
  for (let i = 0; i < window.localStorage.length; i++) {
    const key = window.localStorage.key(i);
    if (key?.startsWith(STORAGE_KEY_PREFIX)) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach((key) => window.localStorage.removeItem(key));
};
